import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Loading } from "@custodio-ai/components";

// Lazy load main components
const Header = React.lazy(() =>
  import("../components/Header").then((module) => ({ default: module.Header })),
);
// const Hero = React.lazy(() => import("../components/Hero").then(module => ({ default: module.Hero })));
// const Features = React.lazy(() => import("../components/Features").then(module => ({ default: module.Features })));
// const HowItWorks = React.lazy(() => import("../components/HowItWorks").then(module => ({ default: module.HowItWorks })));
// const Testimonials = React.lazy(() => import("../components/Testimonials").then(module => ({ default: module.Testimonials })));
// const FAQ = React.lazy(() => import("../components/FAQ").then(module => ({ default: module.FAQ })));
// const CTA = React.lazy(() => import("../components/CTA").then(module => ({ default: module.CTA })));
const Footer = React.lazy(() =>
  import("../components/Footer").then((module) => ({ default: module.Footer })),
);

// Lazy load pages
const TermsOfService = React.lazy(() =>
  import("../pages/TermsOfService").then((module) => ({
    default: module.TermsOfService,
  })),
);
const PrivacyPolicy = React.lazy(() =>
  import("../pages/PrivacyPolicy").then((module) => ({
    default: module.PrivacyPolicy,
  })),
);
const AIEthics = React.lazy(() =>
  import("../pages/AIEthics").then((module) => ({ default: module.AIEthics })),
);
const DataSecurity = React.lazy(() =>
  import("../pages/DataSecurity").then((module) => ({
    default: module.DataSecurity,
  })),
);
const GDPRCompliance = React.lazy(() =>
  import("../pages/GDPRCompliance").then((module) => ({
    default: module.GDPRCompliance,
  })),
);
const AIFeatures = React.lazy(() =>
  import("../pages/AIFeatures").then((module) => ({
    default: module.AIFeatures,
  })),
);
const HowAIWorks = React.lazy(() =>
  import("../pages/HowAIWorks").then((module) => ({
    default: module.HowAIWorks,
  })),
);
const SuccessStories = React.lazy(() =>
  import("../pages/SuccessStories").then((module) => ({
    default: module.SuccessStories,
  })),
);
const AIFAQ = React.lazy(() =>
  import("../pages/AIFAQ").then((module) => ({ default: module.AIFAQ })),
);
const Pricing = React.lazy(() =>
  import("../pages/Pricing").then((module) => ({ default: module.Pricing })),
);
const AIBlog = React.lazy(() =>
  import("../pages/AIBlog").then((module) => ({ default: module.AIBlog })),
);
const HomePage = React.lazy(() =>
  import("../pages/Home").then((module) => ({ default: module.HomePage })),
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Suspense fallback={<Loading />}>
          <Header />
        </Suspense>
        <main>
          <Routes>
            <Route
              path="/"
              element={
                <Suspense fallback={<Loading />}>
                  <HomePage />
                </Suspense>
              }
            />
            <Route
              path="/terms"
              element={
                <Suspense fallback={<Loading />}>
                  <TermsOfService />
                </Suspense>
              }
            />
            <Route
              path="/privacy"
              element={
                <Suspense fallback={<Loading />}>
                  <PrivacyPolicy />
                </Suspense>
              }
            />
            <Route
              path="/ai-ethics"
              element={
                <Suspense fallback={<Loading />}>
                  <AIEthics />
                </Suspense>
              }
            />
            <Route
              path="/data-security"
              element={
                <Suspense fallback={<Loading />}>
                  <DataSecurity />
                </Suspense>
              }
            />
            <Route
              path="/gdpr"
              element={
                <Suspense fallback={<Loading />}>
                  <GDPRCompliance />
                </Suspense>
              }
            />
            <Route
              path="/ai-features"
              element={
                <Suspense fallback={<Loading />}>
                  <AIFeatures />
                </Suspense>
              }
            />
            <Route
              path="/how-ai-works"
              element={
                <Suspense fallback={<Loading />}>
                  <HowAIWorks />
                </Suspense>
              }
            />
            <Route
              path="/success-stories"
              element={
                <Suspense fallback={<Loading />}>
                  <SuccessStories />
                </Suspense>
              }
            />
            <Route
              path="/ai-faq"
              element={
                <Suspense fallback={<Loading />}>
                  <AIFAQ />
                </Suspense>
              }
            />
            <Route
              path="/pricing"
              element={
                <Suspense fallback={<Loading />}>
                  <Pricing />
                </Suspense>
              }
            />
            <Route
              path="/ai-blog"
              element={
                <Suspense fallback={<Loading />}>
                  <AIBlog />
                </Suspense>
              }
            />
          </Routes>
        </main>
        <Suspense fallback={<Loading />}>
          <Footer />
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
